import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import FixedDataTable from 'fixed-data-table';
import $ from 'jquery';
import {
    FloatingActionButton,
    IconButton
} from 'material-ui';
import {
    blue400,
    blueGrey800
} from 'material-ui/styles/colors';
import AddIcon from 'material-ui/svg-icons/content/add';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import ChartIcon from 'material-ui/svg-icons/editor/insert-chart';

const {Table, Column, Cell} = FixedDataTable;
const DateCell = ({rowIndex, data, col, props}) => (
    <Cell {...props}>
        {data.getObjectAt(rowIndex)[col].toLocaleString()}
    </Cell>
);

const ImageCell = ({rowIndex, data, col, props}) => (
    <ExampleImage
        src={data.getObjectAt(rowIndex)[col]}
    />
);

const LinkCell = ({rowIndex, data, col, props}) => (
    <Cell {...props}>
        <a href="#">{data.getObjectAt(rowIndex)[col]}</a>
    </Cell>
);

const TextCell = ({rowIndex, data, col, col2, props}) => {
    let label = (col2 != null) ? data[rowIndex][col][col2] : data[rowIndex][col];
    return (
        <Cell {...props}>
            {label}
        </Cell>
    );
};

const ManageCell = ({rowIndex, data,  props}) => {
    const link = "/project/"+data[rowIndex]['id']+'/manage';
    return (
        <Cell {...props}>
            <Link to={link}>
                <IconButton tooltip="Gérer" style={{padding:0, marginRight: 5, width: 20, height: 20}} iconStyle={{width:20, height:20}}>
                    <SettingsIcon color={blueGrey800}  />
                </IconButton>
            </Link>
        </Cell>
    );
};


class ProjectManager extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const dataList = this.props.projects;
        const height = $(window).height() - 154;
        const width = $(window).width() - 296;
        return (
            <div>
                <div style={{marginBottom: 10}}>
                        <Link to="/project/new">
                            <FloatingActionButton mini backgroundColor={blueGrey800}>
                                <AddIcon />
                            </FloatingActionButton>
                        </Link>
                </div>
                <Table
                    rowHeight={36}
                    headerHeight={30}
                    rowsCount={dataList.length}
                    width={width}
                    height={height}
                    {...this.props}>
                    <Column
                        header={<Cell>Name</Cell>}
                        cell={<TextCell data={dataList} col="name"/>}
                        fixed
                        width={200}
                    />
                    <Column
                        header={<Cell>Statut</Cell>}
                        cell={<TextCell data={dataList} col="state" col2="name"/>}
                        fixed
                        width={200}
                    />
                    <Column
                        header={<Cell>Manage</Cell>}
                        cell={<ManageCell data={dataList}/>}
                        fixed
                        width={200}
                    />
                </Table>
            </div>
        );
    }
}

ProjectManager.propTypes = {
    projects: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        state: state
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //actions: bindActionCreators(action, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManager);


/** WEBPACK FOOTER **
 ** ./src/components/ProjectManager/index.js
 **/